/** @jsx h */
// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import { navigationItemPropType } from '../propTypes';
import PrimaryNavigationMenuItem from './PrimaryNavigationMenuItem';
import PrimaryNavigationMenuItemExtra from './PrimaryNavigationMenuItemExtra';
import MenuWrapper from './MenuWrapper';
import styled from '../utils/styled';
import { mediaBreakpointDownXL } from '../../constants/style-constants';

export const Title = styled.div({
  /* stylelint-disable selector-type-case, selector-type-no-unknown */
  borderTop: '1px solid #343434',
  paddingTop: '30px',
  fontSize: '2rem',
  flex: '1',
  fontFamily: '"Spyscapetwo redacted webfont", sans-serif',
  textTransform: 'uppercase',

  [mediaBreakpointDownXL]: {
    display: 'none',
  },
});

export const ChildContainer = styled.div({
  flex: '2',
  marginRight: '15px',
  padding: '0 50px',
  borderRight: '1px solid rgb(52, 52, 52)',
});

export const ItemContainer = styled.div({
  flex: '1',
  marginRight: '15px',
  padding: '0 50px',
});

const PrimaryNavigationMenuDesktop = ({
  title,
  items,
  itemsExtra,
  open,
  allowForSecondaryNav,
}) => (
  <MenuWrapper id="nav-top" role="menu" open={open} topSpace={allowForSecondaryNav}>
    {title && <Title>{title}</Title>}
    <ChildContainer>
      {items && items.map(item => (
        <PrimaryNavigationMenuItem item={item} />
      ))}
    </ChildContainer>
    <ItemContainer>
      {itemsExtra && itemsExtra.map(item => (
        <PrimaryNavigationMenuItemExtra item={item} />
      ))}
    </ItemContainer>
  </MenuWrapper>
);

PrimaryNavigationMenuDesktop.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(navigationItemPropType),
  itemsExtra: PropTypes.arrayOf(navigationItemPropType),
  open: PropTypes.bool.isRequired,
  allowForSecondaryNav: PropTypes.bool.isRequired,
};

PrimaryNavigationMenuDesktop.defaultProps = {
  title: null,
  items: [],
  itemsExtra: [],
};

export default PrimaryNavigationMenuDesktop;
